export default __webpack_public_path__ + "static/media/over-ons-werkwijze.ab98ea24.webp";